<template>
  <header class="navbar fluid-container" :class="{ offline: !networkOnLine }">
    <nav class="links">
      <a href="#" class="back-btn site-btn" onclick="window.history.go(-1); return false;">
        <svg xmlns="http://www.w3.org/2000/svg" class="icon-tabler-chevron-left" width="22" viewBox="0 0 24 24" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
          <polyline points="15 6 9 12 15 18" />
        </svg>
        <span>{{ $t('Retour') }}</span>
      </a>
      <a href="#" class="logo">
        <img src="@/assets/img/tempo-logo.png" alt="Tempo">
      </a>
      <a :href="'/en/?product=' + ($route.query && $route.query.product ? $route.query.product : '')" v-if="$route.meta.lang === 'fr'" class="lang desktop-only">&nbsp;</a>
      <a :href="'/?product=' + ($route.query && $route.query.product ? $route.query.product : '')" v-else class="lang desktop-only">&nbsp;</a>
      <a :href="'/en/?product=' + ($route.query && $route.query.product ? $route.query.product : '')" v-if="$route.meta.lang === 'fr'" class="lang mobile-only">&nbsp;</a>
      <a :href="'/?product=' + ($route.query && $route.query.product ? $route.query.product : '')" v-else class="lang mobile-only">&nbsp;</a>
    </nav>
  </header>
</template>

<script>
import firebase from 'firebase/app'
import { mapGetters, mapState } from 'vuex'

export default {
  computed: {
    currentLang() {
      return this.$i18n.locale
    },
    ...mapGetters('authentication', ['isUserLoggedIn']),
    ...mapState('authentication', ['user']),
    ...mapState('app', ['networkOnLine', 'appTitle', 'appShortTitle'])
  },
  methods: {
    async logout() {
      await firebase.auth().signOut()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/theme/variables.scss';

.links {
  display: flex;
  align-items: center;
  justify-content: center;

  padding-top: 2.5vw;
  padding-bottom: 4.5vw;

  @media (max-width: 767px) {
    padding-bottom: 45px;
  }

  a {
    min-width: 120px;

    @media (max-width: 767px) {
      min-width: 90px;
    }
  }
}

.lang {
  font-size: 16px;
  text-align: right;
  justify-content: flex-end;
  transition: color $t2 $bounce 0s;

  &:hover {
    color: $colorAccent1;
  }
}

.logo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  width: 100%;
  max-width: 600px;

  img {
    display: block;
    max-width: 255px;

    &.promo {
      max-width: 150px;
    }

    @media (max-width: 767px) {
      max-width: 145px;
    }
  }
}

.back-btn {
  svg {
    stroke: #fff;
  }

  @media (max-width: 767px) {
    padding: 0;
    background: none;
    color: $dark;
    justify-content: flex-start;

    svg {
      stroke: $dark;
    }
  }
}
</style>
